import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Card, CardBody, CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import JanelaDescargaHint, { CardTitleRow } from './JanelaDescargaHint';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { formatNumero } from '../utils/formatters';
import { getLojaLabel } from '../utils/lojaLabel';

const RankingMediaTempoLojaTabelaCard = ({
  data,
  loading,
  totalRegistros,
  paginationState,
  onPaginationChange
}) => {
  const columns = useMemo(() => [
    {
      id: 'posicao',
      accessorKey: 'posicao',
      header: '#',
      size: 70,
      enableSorting: false
    },
    {
      id: 'loja',
      accessorKey: 'loja',
      header: 'Loja',
      size: 260,
      cell: ({ row }) => {
        const label = getLojaLabel(row.original.loja);

        return <LojaCell title={label}>{label}</LojaCell>;
      }
    },
    {
      id: 'quantidadeCargas',
      accessorKey: 'quantidadeCargas',
      header: 'Quantidade de Carga',
      size: 180,
      cell: ({ row }) => formatNumero(row.original.quantidadeCargas)
    },
    {
      id: 'tempoMedioDescarga',
      accessorKey: 'tempoMedioDescarga',
      header: 'Tempo medio',
      size: 150
    }
  ], []);

  return (
    <Card>
      <CardBody>
        <CardTitleRow>
          <CardTitle>Tabela ranking tempo medio de descarga por loja</CardTitle>
          <JanelaDescargaHint />
        </CardTitleRow>
        <CardSubhead>Lista paginada por media de tempo de descarga</CardSubhead>

        <TableArea>
          <TanStackTable
            columns={columns}
            data={Array.isArray(data) ? data : []}
            loading={!!loading}
            isSortable={true}
            withPagination={true}
            manualPagination={true}
            totalItems={totalRegistros || 0}
            controlledPagination={paginationState}
            onPaginationChange={onPaginationChange}
            pageSizeOptions={[5, 10, 25, 50, 100, 150, 200, 250, 300]}
            enableRowColors={true}
            className="mt-3"
          />
        </TableArea>
      </CardBody>
    </Card>
  );
};

const TableArea = styled.div`
  margin-top: 10px;
`;

const LojaCell = styled.div`
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default RankingMediaTempoLojaTabelaCard;
